import { useState } from 'react'
import { CalendarIcon } from 'lucide-react'
import { format } from 'date-fns'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Calendar } from '@/components/ui/calendar'
import { cn } from '@/utils/cn'

interface DatePickerCellProps {
  value: Date | null
  onChange: (date: Date | null) => void
  className?: string
}

export function DatePickerCell({
  value,
  onChange,
  className,
}: DatePickerCellProps) {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'h-8 w-[140px] justify-start text-left text-sm font-normal cursor-pointer',
            !value && 'text-muted-foreground',
            className
          )}
        >
          <CalendarIcon className="mr-2 h-3.5 w-3.5" />
          {value ? format(value, 'MM/dd/yyyy') : 'Select date'}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value ?? undefined}
          onSelect={day => {
            onChange(day ?? null)
            setOpen(false)
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
